const swiperConstructionNew = new Swiper(".construction__news__slider", {
  loop: false,
  spaceBetween: 0,
  slidesPerView: "auto",
  speed: 800,
  pagination: {
    el: ".construction__news__slider-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".construction__news__slider-next",
    prevEl: ".construction__news__slider-prev",
  },
  breakpoints: {
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});
